import { useState, useMemo } from 'react';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';
import DiscoverySocialHero from './components/DiscoverySocialHero';
import DiscoveryFilterBar from './components/DiscoveryFilterBar';
import DiscoveryCategorySection from './components/DiscoveryCategorySection';
import {
  discoveryItems,
  filterDiscoveryItems,
  getTrendingByType,
  type DiscoveryEntityType,
} from '@/mocks/discoverySocial';

const ALL_TYPES: DiscoveryEntityType[] = ['radios', 'locutores', 'programas', 'eventos', 'concursos'];

export default function DiscoveryPage() {
  const [country, setCountry] = useState<string>('Todos');
  const [language, setLanguage] = useState<string>('Todos');
  const [category, setCategory] = useState<string>('Todas');

  const filteredItems = useMemo(
    () => filterDiscoveryItems(discoveryItems, country, language, category),
    [country, language, category],
  );

  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        {/* Hero */}
        <DiscoverySocialHero />

        {/* Filters — sticky */}
        <div className="sticky top-0 z-40 bg-background-50/95 backdrop-blur-md">
          <DiscoveryFilterBar
            country={country}
            language={language}
            category={category}
            onCountryChange={setCountry}
            onLanguageChange={setLanguage}
            onCategoryChange={setCategory}
            totalResults={filteredItems.length}
          />
        </div>

        {/* Results */}
        <div id="discovery-feed">
          {filteredItems.length === 0 ? (
            <section className="py-20 md:py-28 text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-background-100 flex items-center justify-center">
                <i className="ri-search-line text-2xl text-foreground-400"></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-1">Sin resultados</h3>
              <p className="text-sm text-foreground-500 max-w-sm mx-auto">
                Probá cambiando los filtros para descubrir más comunidades.
              </p>
            </section>
          ) : (
            ALL_TYPES.map((type) => {
              const items = getTrendingByType(filteredItems, type);
              return <DiscoveryCategorySection key={type} type={type} items={items} />;
            })
          )}
        </div>
      </main>

      <Footer />
      <div className="md:hidden h-20"></div>
    </div>
  );
}